import React from 'react';

import useMeetApprovedRequest from './UseMeetApprovedRequest';

import WorkFlowNavigation from '../components/navigation/WorkFlowNavigation';
import ApprovedMeetGrid from '../components/grids/approvedMeetGrid/ApprovedMeetGrid';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

const MeetApprovedRequest = () => {
  const {
    location,
    Constants,
    meetApprovedRequestState,
    onApprovedRequestClicked
  } = useMeetApprovedRequest();

  return (
    <div className="row">
      <WorkFlowNavigation headerTitle={`Approved Meet Request Queue${location.state?.isRevisit === true? ' - Requires Revisit' : ' - New Requests'}`}>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <ApprovedMeetGrid
              data={meetApprovedRequestState.arrayData}
              isLoading={meetApprovedRequestState.isArrayLoading}
              onApprovedRequestClicked={onApprovedRequestClicked} />
          </div>
        </div>
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={meetApprovedRequestState.isArrayLoading} />
      </WorkFlowNavigation>
    </div>
  );
};

export default MeetApprovedRequest;